var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdClinicalData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Black{fill:#737374;}\r\n\t.Yellow{fill:#FCB01B;}\r\n\t.Green{fill:#129C49;}\r\n\t.Blue{fill:#387CB7;}\r\n\t.Red{fill:#D02127;}\r\n\t.White{fill:#FFFFFF;}\r\n\t.st0{opacity:0.5;}\r\n\t.st1{opacity:0.75;}\r\n\t.st2{opacity:0.25;}\r\n\t.st3{display:none;fill:#737374;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Green",
    d: "M29,16H15c-0.5,0-1,0.5-1,1v14c0,0.5,0.5,1,1,1h14c0.5,0,1-0.5,1-1V17C30,16.5,29.5,16,29,16z M20.5,28 L17,24.5l1.5-1.5l2,2l5-5l1.5,1.5L20.5,28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M12,10h-2V8h2V10z M22,8h-8v2h8V8z M12,12h-2v2h2V12z M12,16h-2v2h2V16z M12,20h-2v2h2V20z M22,12h-8v2h8V12z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M12,26H6V4h20v10h2V3c0-0.5-0.5-1-1-1H5C4.5,2,4,2.5,4,3v24c0,0.5,0.5,1,1,1h7V26z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdClinicalData);
export default __webpack_public_path__ + "static/media/ordClinicalData.f70ea62b4f9b90ca3f1507e44cef91cb.svg";
export { ForwardRef as ReactComponent };